import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface TabAccessAlertsProps {
  canEdit: boolean;
  hasChanges: boolean;
  viewOnlyText: React.ReactNode;
  unsavedText: React.ReactNode;
}

export const TabAccessAlerts: React.FC<TabAccessAlertsProps> = ({
  canEdit,
  hasChanges,
  viewOnlyText,
  unsavedText,
}) => (
  <>
    {!canEdit && (
      <Alert>
        <AlertDescription>{viewOnlyText}</AlertDescription>
      </Alert>
    )}
    {hasChanges && canEdit && (
      <Alert variant="warning">
        <AlertDescription>{unsavedText}</AlertDescription>
      </Alert>
    )}
  </>
);
